export const RequestsActionType = {
  LOAD_CATEGORIES: "LOAD_CATEGORIES",
  GET_REQUESTS: "GET_REQUESTS",
  GET_PROPSALS: "GET_PROPOSALS",
  SET_LOADING: "SET_LOADING",
  CANCEL_REQUEST: "CANCEL_REQUEST",
  GET_SERVICE_PROVIDER_REQUESTS: "GET_SERVICE_PROVIDER_REQUESTS",
};
